import { debounce } from "lodash";

import { trackPageView, trackLink, trackProductView, trackSiteSearch } from "./tracker";

import { TRACK_PRODUCT_VIEW, TRACK_LINK, ROUTER_LOCATION_CHANGE } from "./actions";
import { SET_SEARCH_TERM_INITIAL } from "@/reducers/materials/constants";
import { getSearchLocation } from "@/reducers/materials";

const trackPageViewDebounced = debounce(trackPageView, 100);

// get path without any unique identifier
function getRouterUrl(state) {
  const urlWithoutSearch = state.router.location ? state.router.location.pathname : "/";
  return urlWithoutSearch.replace(/[{(]?[0-9A-F]{8}[-]?(?:[0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?\//gi, "");
}

export const middleware = (store) => (next) => (action) => {
  try {
    switch (action.type) {
      case ROUTER_LOCATION_CHANGE:
        trackPageViewDebounced(getRouterUrl(store.getState()));
        break;
      case TRACK_PRODUCT_VIEW:
        trackProductView(action.payload);
        trackPageViewDebounced(getRouterUrl(store.getState()));
        break;
      case TRACK_LINK:
        trackLink(action.payload.url, action.payload.linkType);
        // trackPageViewDebounced(getRouterUrl(store.getState()));
        break;
      case SET_SEARCH_TERM_INITIAL:
        if (action.payload) {
          trackSiteSearch(action.payload, getSearchLocation(store.getState()));
          trackPageViewDebounced(getRouterUrl(store.getState()));
        }
        break;
      default:
        break;
    }
  } catch (err) {
    console.warn(err);
  }

  // if (eventTracking[action.type]) {
  //   console.log(eventTracking[action.type], store.getState());
  // }

  return next(action);
};
